import { useTranslation } from "react-i18next";

import ErrorLayout from "@components/layout/ErrorLayout";
import { getRootPath } from "@utils/getRootPath";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <ErrorLayout
      statusCode="404"
      title={t("error.not_found.title")}
      description={t("error.not_found.description")}
    >
      <a
        href={getRootPath(window.location.pathname)}
        className="inline-block btn-secondary text-sm rounded"
      >
        {t("error.go_to_dashboard")}
        <span className="inline-block ml-2" aria-hidden="true">
          &rarr;
        </span>
      </a>
    </ErrorLayout>
  );
};

export default NotFound;
